//@ts-check
import React from 'react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Core.
import { Tooltip } from 'core/components';

import 'react-datepicker/dist/react-datepicker.css';
import './style.scss';

const CustomDatePickDiv = styled.input`
  background-color: white;
  border: solid 1px #bfbfbf;
  border-radius: 0.25em;
  padding: 8px;
  width: 100%;
`;

//TODO: Fix the error about "Type aliases can only be used in TypeScript files.ts(8008)".
/**
 * Custom input for react-datepicker.
 * forwardRef render functions must accept exactly two parameters: props and ref.
 * @param {{ onClick: () => void, value: string }} props
 * @param {React.Ref<HTMLInputElement>} ref
 */
function CustomInputInner({ onClick, value }, ref) {
  return (
    <div className="position-relative" style={{ width: '100%' }}>
      <FontAwesomeIcon
        icon={faCalendarAlt}
        className="position-absolute"
        style={{ left: '8px', top: '12px', zIndex: 1 }}
        onClick={onClick}
      />
      <CustomDatePickDiv
        ref={ref}
        value={value}
        className="font-weight-normal icon-space"
        readOnly
        onClick={onClick}
      />
    </div>
  );
}

const CustomInput = React.forwardRef(CustomInputInner);

/**
 * @param {{
 *    dateId: string
 *    dateName: string
 *    searchDate: string
 *    dateTitle: string
 *    tooltip: string
 *    onChange: (e) => void
 * }} props
 */
function SearchDate({
  dateId,
  dateName,
  searchDate,
  dateTitle,
  tooltip,
  onChange,
}) {
  // Note: the datepicker control was partially hidden by the results table header.
  // Adding the prop portalId fixes this issue.
  return (
    <div className="form-group" id="search-date-field">
      <label>{dateTitle || 'Date'}</label>
      <Tooltip tooltipId="search-date-tooltip">{tooltip}</Tooltip>
      <section>
        <DatePicker
          id={dateId}
          name={dateName}
          // @ts-ignore - Fix the error about "Type 'Date' is not assignable to type 'string'."
          customInput={<CustomInput />}
          dateFormat="yyyy-MM-dd"
          isClearable
          portalId="root-portal"
          // showIcon
          selected={searchDate}
          onChange={onChange}
        />
      </section>
    </div>
  );
}
export { SearchDate };
